export default "/images/printer.svg?64cd3316a4534126358711d946e9eeef";